import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Auth } from 'src/app/models/auth';
import { FilterUseProducts } from 'src/app/models/relatorio';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import { PdfData, PdfService } from 'src/app/shared/services/pdf.service';
import {saveAs} from 'file-saver';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { map, filter, debounceTime, distinctUntilChanged, tap, switchMap, delay, takeUntil } from 'rxjs/operators';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-situacao-cadastro',
  templateUrl: './situacao-cadastro.component.html',
  styleUrls: ['./situacao-cadastro.component.css']
})
export class SituacaoCadastroComponent implements OnInit {
 
  constructor(
    private relatorioService: RelatorioService,
    private authenticationService: AuthenticationService,
    private alertService: NewAlertService,
    public datepipe: DatePipe,
    private modalService: NgbModal,
    private collaboratorsService: ColaboradorService
  ) { }
  
  public currentUser: Auth;
  public filtro = new FilterUseProducts(null,null,null,null,null,false);
  
  //#region filter form
  public collaboratorsServerSideCtrl: FormControl = new FormControl();
  public collaboratorsServerSideFilteringCtrl: FormControl = new FormControl();
  public agroupCtrl: FormControl = new FormControl();
  public collaboratorsFilterText: string;
  public collaboratorsFiltered: any;
  public searching = false;
  protected _onDestroy = new Subject<void>();

  public dataInicio = new Date();
  public dataFim = new Date();
  public verTodos: boolean = false;
  queryDate: Date;
  
  public status: any[];
  public filtroOn: boolean = false;

  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;
  collumnName = "";

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    //this.carregarRelatorio(1);

    this.collaboratorsFiltered = this.collaboratorsServerSideFilteringCtrl.valueChanges
    .pipe(
      map(search => search.trim()),
      filter(search => search.length > 2 || !!search ),
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(search => {
        return this.collaboratorsService.getCollaboratorFilter(this.currentUser.token.assignorGuid, search)
      }),
      map((res: any) => {
        this.searching = false;
        return res.result;
      }),
      delay(500),
      takeUntil(this._onDestroy)
    );
  }

  carregarRelatorio(page){
    this.currentPage = page;
    this.relatorioService.getCollaboratorStatus(this.currentUser.token.assignorGuid,(page-1),+this.showItem,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.status = response.result.collaboratorStatus;
        this.totalItems = response.result.total;   
        this.queryDate = new Date();     
        for (const s of this.status) {
          if (s.document){
            const tam = environment.TOTAL_CARACTERE_CPF - s.document.toString().length;
            let str = s.document.toString();
  
            for (let i = 0; i < tam; i++) { str = '0' + str; }
  
            s.document = str;
          }
        }
      }
    });
  }  

  showItemChanged(event) {
    this.showItem = event;
    this.carregarRelatorio(1);
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  setPeriod(inicio,date: Date){
      if(inicio){
        this.filtro.dateStart  = date;
      } else if(this.filtro.dateStart == null || this.filtro.dateStart >= date) {
          this.filtro.dateEnd = this.filtro.dateStart;
          this.filtro.dateStart = date;
      } else {
          this.filtro.dateEnd = date;
      }
  }
  
  applyFilter() {
    this.filtro.collaboratorsId = [];
    this.collaboratorsFilterText = '';
    let colla: any;
    
    this.verTodos = this.agroupCtrl.value ? this.agroupCtrl.value : false;
    if(!this.verTodos){
      colla = this.collaboratorsServerSideCtrl.value;
    } else {
      colla = null;
      this.filtro.collaboratorsId = null;
    }

    colla?.forEach((x, i) => {
      if(this.filtro.collaboratorsId.indexOf(x.id) == -1){
        this.filtro.collaboratorsId.push(x.id);
        this.collaboratorsFilterText += i==0 ? x.name : ', ' + x.name;
      }
    });

    if(
      (this.filtro.collaboratorsId == null ||
      this.filtro.collaboratorsId.length == 0) &&
      this.verTodos == false
    ){
      this.filtroOn = false;
      this.status = [];
      this.totalItems = 0;
      this.currentPage = 1;
      //this.carregarRelatorio(1);
      this.modalService.dismissAll();
    } else {
      this.filtroOn = true;
      this.carregarRelatorio(1);
      this.modalService.dismissAll();
    }
  }

  deleteFilter(){
    this.filtro.collaboratorsId = null;
    this.verTodos = false
    this.agroupCtrl.setValue(null);
    this.collaboratorsServerSideCtrl.setValue(null);
    this.filtroOn = false;
    this.status = [];
    this.totalItems = 0;
    this.currentPage = 1;
  }

  exportExtractExcel(){
    var result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const excelService = new ExcelService();
    const worksheets = new Array<WorksheetData>();
    const ws = new WorksheetData();
    ws.worksheetTitle = 'situacao_cadastros_' + date[2] + '-' + date[1] + '-' + date[0];
    ws.worksheetHeaders = ['CPF','Favorecido','Situação','Data de desligamento','Cadastrado por','Dia do cadastro','Alteração por','Dia da alteração','Suspenso'];
    ws.WorksheetRows = [];
    // /*
    this.relatorioService.getCollaboratorStatus(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.collaboratorStatus;       
        for (const s of this.status) {;
          const tam = environment.TOTAL_CARACTERE_CPF - s.document.toString().length;
          let str = s.document.toString();
          for (let i = 0; i < tam; i++) { str = '0' + str; }
          s.document = str;
        }
      
        result.forEach((r) => {
          const lr = new Array<string>();
          lr.push(this.formatarCpf(r.document));
          lr.push(r.collaborator);
          lr.push(r.status);
          lr.push(this.datepipe.transform(r.endDate, 'dd/MM/yyyy'));
          lr.push(r.createPerson);
          lr.push(this.datepipe.transform(r.createDate, 'dd/MM/yyyy'));
          lr.push(r.alterationPerson);
          lr.push(this.datepipe.transform(r.alterationDate, 'dd/MM/yyyy'));
          lr.push(r.suspensionDate);
          ws.WorksheetRows.push(lr);
        });

        worksheets.push(ws);

        let filter = '';
        filter += this.filtro.collaboratorsId?.length > 0 ? 'Favorecidos: ' + this.collaboratorsFilterText : ''
        
        excelService.generateExcelReport('Situação de cadastros', worksheets, filter).xlsx
        .writeBuffer().then((data) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          saveAs(blob, ws.worksheetTitle + '.xlsx');
        });

      }
    },
    error => {
      this.alertService.error('Ocorreu um erro ao paginar relatorio');
    });
    // */
  }

  exportExtractPdf(){
    let result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const pdfData = new PdfData();
    pdfData.PdfTitle = 'situacao_cadastros_' + date[2] + '-' + date[1] + '-' + date[0];
    pdfData.PdfHeaders = ['CPF','Favorecido','Situação','Data de desligamento','Cadastrado por','Dia do cadastro','Alteração por','Dia da alteração','Suspenso'];
    pdfData.PdfRows = [];

    this.relatorioService.getCollaboratorStatus(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.collaboratorStatus;       
        for (const s of this.status) {;
          if (s.document){
            const tam = environment.TOTAL_CARACTERE_CPF - s.document.toString().length;
            let str = s.document.toString();
            for (let i = 0; i < tam; i++) { str = '0' + str; }
            s.document = str;
          }
        }
      
        result.forEach((r) => {
          const lr = new Array<string>();
          lr.push(this.formatarCpf(r.document));
          lr.push(r.collaborator);
          lr.push(r.status);
          lr.push(this.datepipe.transform(r.endDate, 'dd/MM/yyyy HH:mm'));
          lr.push(r.createPerson);
          lr.push(this.datepipe.transform(r.createDate, 'dd/MM/yyyy HH:mm'));
          lr.push(r.alterationPerson);
          lr.push(this.datepipe.transform(r.alterationDate, 'dd/MM/yyyy HH:mm'));
          lr.push(r.suspensionDate);
          pdfData.PdfRows.push(lr);
        });

        let filter = '';
        filter += this.filtro.collaboratorsId?.length > 0 ? 'Favorecidos: ' + this.collaboratorsFilterText : ''
        
        const pdfService = new PdfService();
        pdfService.generatePdfReport('Situação de cadastros',pdfData,filter,this.datepipe.transform(this.queryDate, 'dd/MM/yyyy HH:mm:ss'),true).getBlob((blob) => {
          saveAs(blob, pdfData.PdfTitle + '.pdf');
        });

      } else {
        this.alertService.error(response.message);
      }
    },
    error => {
      this.alertService.error(
        'Ocorreu um erro ao paginar o relatorio'
      );
    });
  }

  formatarCpf(cpf){
    if(cpf == null)
      return null
      
    const tam = environment.TOTAL_CARACTERE_CPF - cpf.toString().length;

    for (let i = 0; i < tam; i++) { cpf = '0' + cpf; }

    return cpf.slice(0,3)+"."+cpf.slice(3,6)+"."+cpf.slice(6,9)+"-"+cpf.slice(9);
  }

}